import React, { useState } from 'react';
import styled from 'styled-components';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import Table from '../FormRightContent/Table';
import SelectStyled from 'components/SelectStyled';
import { Checkbox } from 'antd';
import ConditionInput from './ConditionInput';
import UploadImage from './UploadImage';
import InputStyled from 'components/InputStyled';

/**
 * * 오토메 - 작품 정보 수정
 */

interface IProps {
  langList: ISupportLanguage[] | null;
  data: any | null;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  projectId: string | undefined;
}

export interface IVisible {
  create: boolean;
  edit: boolean;
}

const Content: React.FC<IProps> = ({ langList, data, setData, projectId }) => {
  const [visible, setVisible] = useState<IVisible>({
    create: false,
    edit: false,
  });
  const { t } = useTranslation();
  const [selected, setSelected] = useState<null | any>(null);

  return (
    <>
      <OtomeProjectContentWrapper>
        <SectionWarpper>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.loadingContent.update.loadingText',
              )}
              :
            </p>
            <Table
              data={data}
              setSelectedEl={setSelected}
              visible={visible}
              setVisible={setVisible}
              langList={langList}
              setData={setData}
              projectId={projectId}
              selected={selected}
            />
          </div>
        </SectionWarpper>
      </OtomeProjectContentWrapper>
    </>
  );
};

export default Content;

const OtomeProjectContentWrapper = styled.div`
  border: 1px solid #bcbec0;
  padding: 1.5rem 1.5rem;
  border-radius: 8px;
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm} !important;
    font-style: normal !important;
    font-weight: ${theme.fontWeights.normal} !important;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header p {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .header p span {
    font-weight: ${theme.fontWeights.bold};
  }
  .langsTable {
    display: flex;
    flex-wrap: wrap;
  }
  .langsTable-first {
    width: 40%;
  }
  .langsTable-second {
    width: 40%;
  }
  .langsTable-third {
    width: 20%;
    display: flex;
    justify-content: end;
    & > * + * {
      margin-left: 16px;
    }
  }
  .langsTable-first,
  .langsTable-second,
  .langsTable-third {
    border-bottom: 1px solid ${theme.colors.dark_200};
    padding: 12px;
    display: flex;
    align-items: center;
    p {
      font-size: ${theme.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.fontWeights.medium};
      line-height: 16px;
      letter-spacing: 0.2px;
      text-transform: capitalize;
    }
  }
  .title-table {
    font-size: ${theme.fontSizes.normal} !important;
    font-weight: ${theme.fontWeights.bold} !important;
  }
`;
